export class PlayerLayoutSidebars {
    Id: number;
    Name: string;
    IsDeleted: boolean;
    ClientId: number;
    IsGlobal: boolean;
    Svg: string;
}